import { useContext } from 'react';
import { throwError } from '@bnetex/shared/miscUtils';
import type { FirebaseContextProps } from '../lib/firebaseContext';
import { FirebaseContext } from '../lib/firebaseContext';

export const useFirebaseContext = (): FirebaseContextProps =>
    useContext(FirebaseContext) as FirebaseContextProps
    ?? throwError('Firebase context can be accessed only in FirebaseProvider');
